import { render, staticRenderFns } from "./MergeBags.vue?vue&type=template&id=94a9d6c6"
import script from "./MergeBags.vue?vue&type=script&lang=js"
export * from "./MergeBags.vue?vue&type=script&lang=js"
import style0 from "./MergeBags.vue?vue&type=style&index=0&id=94a9d6c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports